export const HUNYUAN_TRANSLATION_LANGUAGE_OPTIONS = Object.freeze([
  { code: 'zh', name: '简体中文 (zh)' },
  { code: 'zh-TR', name: '繁体中文 (zh-TR)' },
  { code: 'yue', name: '粤语 (yue)' },
  { code: 'en', name: 'English (en)' },
  { code: 'fr', name: 'Français (fr)' },
  { code: 'pt', name: 'Português (pt)' },
  { code: 'es', name: 'Español (es)' },
  { code: 'ja', name: '日本語 (ja)' },
  { code: 'tr', name: 'Türkçe (tr)' },
  { code: 'ru', name: 'Русский (ru)' },
  { code: 'ar', name: 'العربية (ar)' },
  { code: 'ko', name: '한국어 (ko)' },
  { code: 'th', name: 'ไทย (th)' },
  { code: 'it', name: 'Italiano (it)' },
  { code: 'de', name: 'Deutsch (de)' },
  { code: 'vi', name: 'Tiếng Việt (vi)' },
  { code: 'ms', name: 'Bahasa Melayu (ms)' },
  { code: 'id', name: 'Bahasa Indonesia (id)' },
]);

const CANONICAL_CODE_MAP = Object.freeze(
  HUNYUAN_TRANSLATION_LANGUAGE_OPTIONS.reduce((acc, { code }) => {
    acc[code.toLowerCase()] = code;
    return acc;
  }, {})
);

const LANGUAGE_CODE_ALIASES = Object.freeze({
  kr: 'ko',
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-sg': 'zh',
  'zh-tw': 'zh-TR',
  'zh-hant': 'zh-TR',
  'zh-hk': 'zh-TR',
  'zh-mo': 'zh-TR',
});

export const normalizeHunyuanTranslationLanguage = languageCode => {
  if (!languageCode) {
    return '';
  }

  const normalized = languageCode
    .toString()
    .trim()
    .replace(/_/g, '-')
    .toLowerCase();
  if (!normalized) {
    return '';
  }

  const aliased = LANGUAGE_CODE_ALIASES[normalized] || normalized;
  const canonicalKey = aliased.toLowerCase();
  if (CANONICAL_CODE_MAP[canonicalKey]) {
    return CANONICAL_CODE_MAP[canonicalKey];
  }

  const baseLanguage = aliased.split('-')[0];
  return CANONICAL_CODE_MAP[baseLanguage] || '';
};
